import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { MasterParamEditForm } from "@/features/master-param/MasterParamEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function MasterParamEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/master-param",
            label: "Master Param",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit Master Param</H2>
      <MasterParamEditForm id={id} />
    </>
  );
}
